<template>
  <div class="font-sans bg-gray-200 flex flex-col min-h-screen w-full">
    <div class="sticky top-0 z-20">
      <div class="flex items-center justify-between bg-indigo-600 px-4 py-4">
        <div class="header font-medium text-2xl flex items-center">
          <img
            src="@/assets/images/logo.svg"
            class="h-12 object-contain mr-4"
          />
          <span class="hidden text-white mr-4">MDM Educación</span>
          <span v-if="this.user.admin === '0'" class="text-gray-400">{{
            user.colegio_title
          }}</span>
          <VSelect
            v-else-if="this.user.admin === '1'"
            :options="schoolGroups"
            :clearable="false"
            :value="this.user.colegio_title"
            :tab-index="-1"
            @input="changeSchoolGroup"
          />
        </div>
        <div class="flex items-center">
          <div
            v-if="user.profesor !== '1' && lastExport"
            class="flex flex-col mr-4 text-white"
          >
            <span class="text-xs">Última exportación:</span>
            <span class="text-sm">{{ lastExportDate }}</span>
          </div>
          <a
            v-if="user.profesor !== '1'"
            :href="downloadHref"
            class="text-white text-2xl font-medium hover:opacity-50 mr-4"
            title="Exportar zip"
            ><i class="fa fa-arrow-alt-circle-down"></i
          ></a>
          <button
            v-if="user.profesor !== '1'"
            class="text-white text-2xl font-medium hover:opacity-50 mr-4"
            title="Actualizar datos"
            @click="showDataModal"
          >
            <i class="fa fa-sync"></i>
          </button>
          <button
            v-if="user.profesor !== '1'"
            class="text-white text-2xl font-medium hover:opacity-50 mr-4"
            title="Configuración"
            @click="showConfigurationModal"
          >
            <i class="fa fa-cog"></i>
          </button>
          <button
            class="text-white text-2xl font-medium hover:opacity-50"
            title="Salir"
            @click="logout"
          >
            <i class="fa fa-sign-out-alt"></i>
          </button>
        </div>
      </div>
      <div
        class="flex justify-between bg-white text-gray-500 border-b px-4 py-4 z-40"
      >
        <div class="tabs">
          <button
            v-for="tab in allowedTabs"
            :key="tab.id"
            class="focus:outline-none hover:text-gray-900 mr-8"
            :class="{
              'text-blue-700 font-bold': tab.id === selectedTab,
            }"
            @click="selectTab(tab)"
          >
            {{ tab.title }}
          </button>
        </div>
      </div>
    </div>
    <Filters v-if="currentTab.filters.length > 0 && !loading" />
    <Table v-if="!loading" />
    <Pagination />
    <div v-if="!loading" class="fixed right-0 bottom-0 z-30 mb-20 mr-6 flex">
      <button
        v-if="selectedTab === 4 && copiedTeachers.length"
        title="Pegar profesor(es)"
        class="shadow-lg w-16 h-16 text-white focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
        :class="[
          checkedEntries.length
            ? 'bg-red-400 hover:bg-red-600'
            : 'bg-red-400 hover:bg-red-600',
        ]"
        @click="pasteTeachers"
      >
        <i class="fas fa-paste"></i>
      </button>
      <button
        v-if="selectedTab === 4 && currentTab.entries.length"
        title="Copiar profesor(es)"
        class="shadow-lg w-16 h-16 text-white focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
        :class="[
          checkedEntries.length
            ? 'bg-orange-400 hover:bg-orange-600'
            : 'bg-blue-600 hover:bg-blue-800',
        ]"
        @click="copyTeachers"
      >
        <i class="fas fa-copy"></i>
      </button>
      <button
        v-if="selectedTab === 3 && currentTab.entries.length"
        title="Asignar a asignatura(s)"
        class="shadow-lg w-16 h-16 text-white focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
        :class="[
          checkedEntries.length
            ? 'bg-orange-400 hover:bg-orange-600'
            : 'bg-blue-600 hover:bg-blue-800',
        ]"
        @click="showAsignSubjectModal"
      >
        <i class="fas fa-chalkboard-teacher"></i>
      </button>
      <button
        v-if="
          user.profesor !== '1' &&
          selectedTab === 5 &&
          currentTab.entries.length
        "
        title="Enviar correo Alumno no Encontrado"
        class="shadow-lg w-16 h-16 text-white focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
        :class="[
          checkedEntries.length === 1
            ? 'bg-orange-400 hover:bg-orange-600'
            : 'bg-blue-600 hover:bg-blue-800',
        ]"
        @click="showSendMailModal"
      >
        <i class="fas fa-envelope"></i>
      </button>
      <button
        v-if="
          user.profesor !== '1' &&
          (selectedTab === 3 || selectedTab === 5) &&
          currentTab.entries.length
        "
        title="Generar stickers"
        class="shadow-lg w-16 h-16 text-white focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
        :class="[
          checkedEntries.length
            ? 'bg-orange-400 hover:bg-orange-600'
            : 'bg-blue-600 hover:bg-blue-800',
        ]"
        @click="showStickersMakerModal"
      >
        <i class="fas fa-sticky-note"></i>
      </button>
      <button
        v-if="selectedTab === 5 && currentTab.entries.length"
        title="Asignar curso y grupo"
        class="shadow-lg w-16 h-16 text-white focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
        :class="[
          checkedEntries.length
            ? 'bg-orange-400 hover:bg-orange-600'
            : 'bg-blue-600 hover:bg-blue-800',
        ]"
        @click="showAsignGroupModal"
      >
        <i class="fas fa-user-graduate"></i>
      </button>
      <button
        v-if="selectedTab === 5 && currentTab.entries.length"
        title="Subir curso"
        class="shadow-lg w-16 h-16 text-white focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
        :class="[
          checkedEntries.length
            ? 'bg-orange-400 hover:bg-orange-600'
            : 'bg-blue-600 hover:bg-blue-800',
        ]"
        @click="increaseCourseAll"
      >
        <i class="fas fa-arrow-up"></i>
      </button>
      <button
        v-if="selectedTab === 5 && currentTab.entries.length"
        title="Bajar curso"
        class="shadow-lg w-16 h-16 text-white focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
        :class="[
          checkedEntries.length
            ? 'bg-orange-400 hover:bg-orange-600'
            : 'bg-blue-600 hover:bg-blue-800',
        ]"
        @click="decreaseCourseAll"
      >
        <i class="fas fa-arrow-down"></i>
      </button>
      <button
        v-if="
          user.profesor !== '1' &&
          selectedTab !== 6 &&
          selectedTab !== 7 &&
          selectedTab !== 8
        "
        @click="exportTable"
        title="Descargar datos"
        class="shadow-lg w-16 h-16 bg-blue-600 text-white hover:bg-blue-800 focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
      >
        <i class="fas fa-file-download"></i>
      </button>
      <button
        v-if="selectedTab === 8"
        @click="restoreEntries"
        title="Restaurar entradas filtradas"
        class="shadow-lg w-16 h-16 text-white focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
        :class="[
          checkedEntries.length
            ? 'bg-orange-400 hover:bg-orange-600'
            : 'bg-blue-600 hover:bg-blue-800',
        ]"
      >
        <i class="fas fa-trash-restore-alt"></i>
      </button>
      <button
        v-if="selectedTab === 8"
        @click="forceDeleteEntries"
        title="Eliminar permanentemente entradas filtradas"
        class="shadow-lg w-16 h-16 text-white focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
        :class="[
          checkedEntries.length
            ? 'bg-orange-400 hover:bg-orange-600'
            : 'bg-blue-600 hover:bg-blue-800',
        ]"
      >
        <i class="fas fa-times"></i>
      </button>
      <button
        v-if="
          user.profesor !== '1' &&
          selectedTab !== 6 &&
          selectedTab !== 7 &&
          selectedTab !== 8
        "
        @click="removeEntries"
        title="Eliminar entradas filtradas"
        class="shadow-lg w-16 h-16 text-white focus:outline-none rounded-full flex items-center justify-center text-2xl mr-4"
        :class="[
          checkedEntries.length
            ? 'bg-orange-400 hover:bg-orange-600'
            : 'bg-blue-600 hover:bg-blue-800',
        ]"
      >
        <i class="fas fa-trash-alt"></i>
      </button>
      <button
        v-if="
          user.profesor !== '1' &&
          selectedTab !== 6 &&
          selectedTab !== 7 &&
          selectedTab !== 8
        "
        title="Añadir entrada"
        class="shadow-lg w-16 h-16 bg-blue-600 text-white hover:bg-blue-800 focus:outline-none rounded-full flex items-center justify-center text-2xl"
        @click="showAddEntryModal"
      >
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <div
      v-if="loading"
      class="flex items-center justify-center w-screen h-screen fixed bg-white opacity-75 z-50"
    >
      <span class="text-blue-500 opacity-75">
        <i class="fas fa-circle-notch fa-spin fa-5x"></i>
      </span>
    </div>
    <Modal />
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import VSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Swal from "sweetalert2";

import AddEntry from "@/components/AddEntry";
import AsignSubjects from "@/components/AsignSubjects";
import Configuration from "@/components/Configuration";
import Filters from "@/components/Filters";
import FtpData from "@/components/FtpData";
import Modal from "@/components/Modal";
import Pagination from "@/components/Pagination";
import SendMail from "@/components/SendMail";
import StickersMaker from "@/components/StickersMaker";
import Table from "@/components/Table";
import AsignCourseAndGroup from "@/components/AsignCourseAndGroup.vue";

export default {
  components: {
    Filters,
    Modal,
    Pagination,
    Table,
    VSelect,
  },
  data() {
    return {
      lastExport: null,
      copiedTeachers: [],
      schoolGroups: [],
    };
  },
  computed: {
    ...mapState([
      "user",
      "loading",
      "tabs",
      "selectedTab",
      "sortField",
      "sortDirection",
    ]),
    ...mapGetters(["currentTab"]),
    teachersToPaste() {
      return [
        ...new Set(
          this.copiedTeachers.reduce((acc, teachers) => {
            if (teachers === "") return acc;
            acc = [...acc, ...teachers.split(",")];
            return acc;
          }, [])
        ),
      ].join(",");
    },
    allowedTabs() {
      if (this.user.admin === "1") {
        return this.tabs;
      }

      const professorsIndexes = [3, 4];
      return this.tabs.filter((tab, index) => {
        if (this.user.profesor === "1") {
          return professorsIndexes.includes(index);
        } else {
          return tab.adminOnly === false;
        }
      });
    },
    checkedEntries: {
      set(entries) {
        this.$store.state.checkedEntries = entries;
      },
      get() {
        return this.$store.state.checkedEntries;
      },
    },
    schoolGroup() {
      return this.user.colegio_title;
    },
    downloadHref() {
      return `server/index.php?action=downloadCSV&colegio=${this.user.colegio}`;
    },
    lastExportDate() {
      const date = new Date(this.lastExport * 1000);

      return date.toLocaleString("es-ES");
    },
  },
  methods: {
    ...mapActions(["selectTab", "requestEntries", "getData", "checkPassword"]),
    ...mapMutations(["changeUser", "showModal", "toggleLoading"]),
    async pasteTeachers() {
      const check = await this.checkPassword(
        `¿Seguro de pegar los profesores copiados?`
      );

      if (!check) {
        return;
      }

      const subjects = this.checkedEntries.length
        ? this.checkedEntries
        : this.currentTab.entries;
      const data = subjects.map((subject) => {
        return {
          ID_Curso: subject.ID_Curso,
          descripcion: subject.descripcion,
          colegio: this.user.colegio,
          profesores: this.teachersToPaste,
        };
      });
      axios
        .post("server/index.php", {
          action: "importDisciplines",
          user: this.user.num,
          colegio: this.user.colegio,
          data,
        })
        .then(() => {
          this.copiedTeachers = [];
          this.checkedEntries = [];
          this.requestEntries();
        });
    },
    copyTeachers() {
      const subjects = this.checkedEntries.length
        ? this.checkedEntries
        : this.currentTab.entries;

      this.copiedTeachers = subjects.map((subject) => subject.profesores);

      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        icon: "success",
        title: "Profesor(es) copiado(s)!",
      });
    },
    changeSchoolGroup(schoolGroup) {
      axios
        .post("server/index.php", {
          action: "getSchoolsInsideGroup",
          schoolGroup: schoolGroup.id,
          timestamp: Date.now(),
        })
        .then((response) => {
          const user = {
            ...this.user,
            colegio: schoolGroup.id,
            colegio_title: schoolGroup.label,
            grupos: response.data.grupos,
          };

          this.changeUser(user);
          localStorage.setItem("user", JSON.stringify(user));

          this.$router.go(0);
        });
    },
    logout() {
      this.changeUser(null);
      localStorage.removeItem("user");

      this.$router.push("/login");
    },
    showDataModal() {
      this.showModal({
        component: FtpData,
        title: "Actualizar datos",
      });
    },
    showAddEntryModal() {
      this.showModal({
        component: AddEntry,
        title: "Crear entrada",
      });
    },
    showConfigurationModal() {
      this.showModal({
        component: Configuration,
        title: "Configuración centro",
      });
    },
    showAsignGroupModal() {
      const students = this.checkedEntries.length
        ? this.checkedEntries
        : this.currentTab.entries;

      this.showModal({
        component: AsignCourseAndGroup,
        props: {
          students,
        },
        title: "Asignar curso y grupo",
      });
    },
    showAsignSubjectModal() {
      const teachers = this.checkedEntries.length
        ? this.checkedEntries
        : this.currentTab.entries;

      this.showModal({
        component: AsignSubjects,
        props: {
          teachers,
        },
        title: "Asignar a asignatura(s)",
      });
    },
    async increaseCourseAll() {
      const entries = this.checkedEntries.length
        ? this.checkedEntries
        : this.currentTab.entries;

      const check = await this.checkPassword(
        `¿Seguro de subir de curso a ${entries.length} alumnos?`
      );

      if (!check) {
        return;
      }

      const data = entries.reduce((acc, entry) => {
        const currentCourse = this.currentTab.extras.courses.find((course) => {
          return entry.ID_Curso === course.ID_Curso;
        });

        const nextCourse = this.currentTab.extras.courses.find((course) => {
          return (
            entry.ID_Location === course.ID_Location &&
            Number(currentCourse.orden) + 1 === Number(course.orden)
          );
        });

        if (nextCourse) {
          acc.push({
            num: entry.num,
            ID_Curso: nextCourse.ID_Curso,
          });
        }

        return acc;
      }, []);

      axios
        .post("server/index.php", {
          action: "decreaseCourse",
          user: this.user.num,
          colegio: this.user.colegio,
          data,
        })
        .then(() => {
          this.checkedEntries = [];
          this.requestEntries();
        });
    },
    async decreaseCourseAll() {
      const entries = this.checkedEntries.length
        ? this.checkedEntries
        : this.currentTab.entries;

      const check = await this.checkPassword(
        `¿Seguro de bajar de curso a ${entries.length} alumnos?`
      );

      if (!check) {
        return;
      }

      const data = entries.reduce((acc, entry) => {
        const currentCourse = this.currentTab.extras.courses.find((course) => {
          return entry.ID_Curso === course.ID_Curso;
        });

        if (Number(currentCourse.orden) === 1) {
          return acc;
        }

        const prevCourse = this.currentTab.extras.courses.find((course) => {
          return (
            entry.ID_Location === course.ID_Location &&
            Number(currentCourse.orden) - 1 === Number(course.orden)
          );
        });

        if (prevCourse) {
          acc.push({
            num: entry.num,
            ID_Curso: prevCourse.ID_Curso,
          });
        }

        return acc;
      }, []);

      axios
        .post("server/index.php", {
          action: "decreaseCourse",
          user: this.user.num,
          colegio: this.user.colegio,
          data,
        })
        .then(() => {
          this.checkedEntries = [];
          this.requestEntries();
        });
    },
    showSendMailModal() {
      if (this.checkedEntries.length !== 1) {
        return;
      }

      const student = this.checkedEntries[0];

      this.showModal({
        component: SendMail,
        title: `Enviar correo a padre de alumno: ${student.nombre} ${student.apellidos} (${student.ID_Alumno})`,
        props: {
          entry: student,
        },
      });
    },
    async showStickersMakerModal() {
      const checkedEntries = this.checkedEntries.length
        ? this.checkedEntries
        : this.currentTab.entries;

      const isStudent = this.selectedTab === 5;

      let entries = [];
      if (isStudent === true) {
        const courses = await this.getData("getAllCourses");

        entries = checkedEntries.map((student) => {
          const course = courses.find((course) => {
            return course.ID_Curso === student.ID_Curso;
          });
          if (course === undefined) {
            return student;
          } else {
            return { ...student, descripcion: course.descripcion };
          }
        });
      } else {
        entries = checkedEntries;
      }

      this.showModal({
        component: StickersMaker,
        props: {
          entries,
          student: isStudent,
        },
        title: "Generar stickers",
      });
    },
    exportTable() {
      const type = this.currentTab.type;
      const nums = this.currentTab.entries.map((entry) => {
        return entry.num;
      });

      axios
        .post(
          "server/index.php",
          {
            action: "downloadCSVSingle",
            type,
            nums,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${type}.csv`);
          link.click();
          window.URL.revokeObjectURL(url);
        });
    },
    async restoreEntries() {
      const entries = this.checkedEntries.length
        ? this.checkedEntries
        : this.currentTab.entries;

      const check = await this.checkPassword(
        `¿Seguro de restaurar ${entries.length} entrada(s)?`
      );

      if (!check) {
        return;
      }

      const data = entries.map((entry) => {
        return {
          table: entry.table,
          num: entry.record_num,
        };
      });

      axios
        .post("server/index.php", {
          action: "restoreEntries",
          user: this.user.num,
          colegio: this.user.colegio,
          data,
        })
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Entrada(s) restaurada(s)!",
          }).then(() => {
            this.checkedEntries = [];
            this.requestEntries();
          });
        });
    },
    async forceDeleteEntries() {
      const entries = this.checkedEntries.length
        ? this.checkedEntries
        : this.currentTab.entries;

      const check = await this.checkPassword(
        `¿Seguro de eliminar permanentemente ${entries.length} entrada(s)?`
      );

      if (!check) {
        return;
      }

      const indev = localStorage.getItem("indev") !== null;

      const data = entries.map((entry) => {
        return {
          indev,
          table: entry.table,
          num: entry.record_num,
          name: entry.record_name,
        };
      });

      axios
        .post("server/index.php", {
          action: "forceDeleteEntries",
          user: this.user.num,
          colegio: this.user.colegio,
          data,
        })
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Entrada(s) elminada(s)!",
          }).then(() => {
            this.checkedEntries = [];
            this.requestEntries();
          });
        });
    },
    async removeEntries() {
      const entries = this.checkedEntries.length
        ? this.checkedEntries
        : this.currentTab.entries;

      const check = await this.checkPassword(
        `¿Seguro de eliminar ${entries.length} entrada(s)?`
      );

      if (!check) {
        return;
      }

      const type = this.currentTab.type;
      const nums = entries.map((entry) => {
        return entry.num;
      });

      axios
        .post("server/index.php", {
          action: "deleteEntries",
          user: this.user.num,
          colegio: this.user.colegio,
          type,
          nums,
        })
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Entrada(s) eliminada(s)!",
          }).then(() => {
            this.checkedEntries = [];
            this.requestEntries();
          });
        });
    },
  },
  async created() {
    this.selectTab(this.allowedTabs[0]);

    this.getData("getHistory").then((exports) => {
      this.lastExport = Math.max(...exports.map((zip) => zip.timestamp));
    });

    this.getData("getSchoolGroups").then((groups) => {
      this.schoolGroups = groups.map((group) => {
        return {
          id: group.num,
          label: group.title,
        };
      });
    });
  },
};
</script>

<style>
.header .vs__dropdown-toggle {
  border: none;
  padding: 0;
}

.header .vs__search,
.header .vs__search:focus {
  line-height: inherit;
  font-size: inherit;
  border: none;
  margin: 0;
}

.header .vs__search:focus {
  position: absolute;
  width: 100%;
}

.header .vs__dropdown-menu {
  border-color: transparent;
}

.header .vs__selected {
  position: relative !important;
  color: #cbd5e0;
}

.header .vs--single.vs--open .vs__selected-options {
  margin-right: 14px;
}

.header .vs--single.vs--searching .vs__selected {
  display: flex;
  visibility: hidden;
}

.header .vs__open-indicator {
  fill: #cbd5e0;
}

.header .vs__search {
  color: #cbd5e0;
}

.header .vs__selected {
  margin: 0;
}

.header .vs__no-options,
.header .vs__dropdown-option {
  font-size: 0.75rem;
  padding: 3px 10px;
}
</style>
